import { selectFactory } from '../helpers';

import { FIELDS } from './constants';

export const selectInsuranceCalculation = ({ insuranceCalculation }) => {
  return insuranceCalculation;
};

export const selectField = selectFactory({ selector: selectInsuranceCalculation });

export const selectErrors = selectField(FIELDS.ERRORS);
export const selectNestedErrors = selectFactory({ fallback: '', selector: selectErrors });

export const selectApplicationId = selectField(FIELDS.APPLICATION_ID);

export const selectIsInCredit = selectField(FIELDS.IS_IN_CREDIT);

export const selectSelectedBank = selectField(FIELDS.SELECTED_BANK);

export const selectWorksheetId = selectField(FIELDS.WORKSHEET_ID);

export const selectInsuranceClientId = (state) => {
  return (
    state.insuranceCalculation?.clientId ||
    state.startPage?.clientId ||
    state.startPage?.application?.client?.id
  );
};
